// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.search.HpApiSearchV3Handler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type {
  HpApiResponseDto,
  HpFilterMetadataResponseDto,
  HpSearchDotsRequestDto,
  HpSearchDotsResponseDto,
  HpSearchListingsRequestDto,
  HpSearchListingsResponseDto,
  HpSearchSlugRegistryDto,
} from '../..';

export const HpApiSearchV3Handler_dots_Path = '/api/web/v3/search/dots';

/**
 * Returns dot map listings for resolved V3 search filters
 */
export const HpApiSearchV3Handler_dots = (postData: HpSearchDotsRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpSearchDotsRequestDto, HpApiResponseDto<HpSearchDotsResponseDto>>(
    {
      endpoint: HpApiSearchV3Handler_dots_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};

export const HpApiSearchV3Handler_filterMetadata_Path = '/api/web/v3/search/filterMetadata';

/**
 * Returns the filter sections clients render; search request selections reference their keys
 */
export const HpApiSearchV3Handler_filterMetadata = (client = getClient()) => {
  return httpApiRequest<never, never, HpApiResponseDto<HpFilterMetadataResponseDto>>(
    {
      endpoint: HpApiSearchV3Handler_filterMetadata_Path,
      method: 'GET',
      contextPath: '/hotpads-api',
    },
    client,
  );
};

export const HpApiSearchV3Handler_listings_Path = '/api/web/v3/search/listings';

/**
 * Unified search endpoint - returns listings, resolved slug, canonical URL, and SEO
 */
export const HpApiSearchV3Handler_listings = (postData: HpSearchListingsRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpSearchListingsRequestDto, HpApiResponseDto<HpSearchListingsResponseDto>>(
    {
      endpoint: HpApiSearchV3Handler_listings_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};

export const HpApiSearchV3Handler_slugs_Path = '/api/web/v3/search/slugs';

/**
 * Returns the search slug registry for validation, display, and redirects
 */
export const HpApiSearchV3Handler_slugs = (client = getClient()) => {
  return httpApiRequest<never, never, HpApiResponseDto<HpSearchSlugRegistryDto>>(
    {
      endpoint: HpApiSearchV3Handler_slugs_Path,
      method: 'GET',
      contextPath: '/hotpads-api',
    },
    client,
  );
};
